


export function log(messageOrObj){
  // TODO more elaborate logging as needed
  console.log(messageOrObj);
}

